<template>
  <DelDialog :showClose="true" :dialogVisible="batchAddVisible" @handleClose="handleCancel"
    @handleConfirm="handleConfirm">
    <template #title>{{ $t("managementV2.batchAdd") }}</template>
    <div class="dialog-content">
      <!-- 角色选择 -->
      <div class="role-box">
        <span>{{ $t("managementV2.addAs") }}：</span>
        <el-select v-model="roleId">
          <el-option v-for="item in roleList" :key="item.id"
            :label="$i18n.locale === 'zh' ? item.name : $roleCase[item.roleType]" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="tree-table">
        <div class="tree" ref="tree">
          <div class="fileter">
            <el-input v-model.trim="searchVal" :placeholder="$t('projectDetailsV2.search')" size="small" clearable
              @clear="changeClear" @focus="handleFocus">
            </el-input>
            <i class="search_i" @click="handelerSeachClick"></i>
          </div>
          <div class="list-box" v-if="!isShowSearchBox" v-show="isShowListBox">
            <!-- 面包屑 -->
            <div class="title">
              <!-- 全选 -->
              <el-checkbox v-model="checkedAll" @change="changeCheckedAll"></el-checkbox>
              <div class="breadcrumb" ref="breadcrumb">
                <span v-for="(item, index ) in breadcrumbList" :key="item.id"
                  :class="{ active: index == breadcrumbList.length - 1 }" @click="handelerClickBread(item, index)">
                  {{ item.name }}
                </span>
              </div>
            </div>
            <div class="depart-box">
              <!-- 滚动请求 -->
              <!-- <div class="depart-box" ref="scrollBox" @scroll="toLoadMore"> -->
              <!-- 部门列表 -->
              <div class="depart-list">
                <div class="depart-list-item" v-for="item in curDepartList" :key="item.id">
                  <el-checkbox v-model="item.checked" @change="(val) => changeCheckBox(val, item)"></el-checkbox>
                  <div class="depart-info">
                    <el-tooltip class="item" effect="dark" :content="`${item.name}`" placement="top-start"
                      :disabled="isShowTooltip">
                      <div class="depart-name" @mouseover="onMouseOver(item.id)">
                        <span :ref="`str${item.id}`">{{ item.name }}</span>
                      </div>
                    </el-tooltip>
                    <span class="depart-num">（{{ item.departCount }}）</span>
                  </div>
                  <div class="depart-children">
                    <span v-if="!item.checked" @click="toChildrenDepart(item)">{{ $t('managementV2.subordinate') }}</span>
                    <el-link type="primary" disabled v-else>{{ $t('managementV2.subordinate') }}</el-link>
                  </div>
                </div>
              </div>
              <!-- 人员列表 -->
              <div class="person-list">
                <div class="person-list-item" v-for=" i in curStudentList" :key="i.id">
                  <el-checkbox v-model="i.checked" @change="(val) => changeCheckBox(val, i)"
                    :disabled="i.companyStatus == 1"></el-checkbox>
                  <div class="person-info">
                    <span>{{ i.nickName.charAt(0) }}</span>
                    <div class="person-name">{{ i.nickName }}</div>
                  </div>
                  <div class="hasjoin" v-if="i.companyStatus == 1">
                    <span class="join-ico"></span>
                    <span>{{ $t('managementV2.joined') }}</span>
                  </div>
                </div>
              </div>
              <div v-show="hasNotMore" class="hasnotmore">
                <span>{{ $t('managementV2.hasNotMore') }}...</span>
              </div>
            </div>
          </div>
          <div class="search-box" v-else>
            <el-card>
              <span v-if="searchList.length == 0">{{ $t('managementV2.startSearchByKeyword') }}</span>
              <div v-else class="search-list">
                <!-- 人员列表 -->
                <div class="person-list">
                  <!-- <div class="person-list" ref="searchScrollBox" @scroll="toLoadMoreSearch"> -->
                  <div class="person-list-item" v-for=" i in searchList" :key="i.id">
                    <el-checkbox v-model="i.checked" @change="(val) => changeSearchCheckBox(val, i)"
                      :disabled="i.companyStatus == 1"></el-checkbox>
                    <div class="person-info">
                      <span class="avtor">{{ i.nickName.charAt(0) }}</span>
                      <div class="person-name">{{ i.nickName }}</div>
                    </div>
                    <div class="hasjoin" v-if="i.companyStatus == 1">
                      <span class="join-ico"></span>
                      <span>{{ $t('managementV2.joined') }}</span>
                    </div>
                  </div>
                  <div v-show="hasNotMoreSearch" class="hasnotmore">
                    <span>{{ $t('managementV2.hasNotMore') }}...</span>
                  </div>
                </div>
              </div>
            </el-card>
          </div>

        </div>
        <div class="table">
          <div class="checked-title">
            <div class="checked-title-icon"></div>
            <div class="checked-title-text">{{ $t('managementV2.selected') }}</div>
          </div>
          <div class="checked-list">
            <el-tag v-for="tag in checkedList" :key="tag.id" :closable="handleClosable(tag)" type=""
              @close="handleClose(tag)">
              {{ tag.name || tag.nickName }}
            </el-tag>
          </div>
        </div>
      </div>

    </div>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import {
  getRoleId,
  queryPageTeam,
  inviteUserBatch,
  queryUserDepartTree,
} from "@/services/teamManagement";

export default {
  name: 'BatchAddUser',
  components: {
    DelDialog
  },
  props: {
    batchAddVisible: {
      typeof: Boolean,
      require: true,
    },
    roleList: {                   // 下拉框数据
      typeof: Array,
      require: true,
    }
  },
  data() {
    return {
      userDepartTreeData: [],      // 批量添加树形数据
      roleId: '',
      query: {
        filter: {
          departId: '',
          nickName: '',
        },
        page: 1,
        rows: 10,
        sort: {},
      },
      tableDataInfo: {
        totalRows: 0,
        totalPage: 0,
      },
      multipleSelection: [],        // 多选选中的数组
      roleArr: [
        {
          value: 3,
          label: this.$t('managementV2.leader')
        },
        {
          value: 1,
          label: this.$t('managementV2.teacher')
        },
        {
          value: 2,
          label: this.$t('managementV2.student')
        },
        {
          value: 0,
          label: this.$t('managementV2.ordinary')
        }
      ],                             // 列表角色
      defaultExpandedKeys: [],
      noGroupId: 0,        // 未分组id
      treeData: [],       //原始部门列表
      departList: [],       //部门列表
      curDepartList: [],    //当前部门列表
      curStudentList: [],   //当前学生成员列表
      isDefaultGroup: {},   //未分组的信息
      curGroup: {},         //当前分组
      checkedAll: false,    //全选
      checkedList: [],        //被选中的部门和人员
      searchVal: '',        //搜索关键字
      searchList: [],        //搜索结果
      isShowSearchBox: false,  //是否展示搜索列表
      breadcrumbList: [],  //面包屑列表
      isShowListBox: false,  //是否展示列表
      stuPage: 1,  //学生分页
      stuRows: 20,  //学生条数
      searchPage: 1,  //搜索分页
      searchRows: 30,  //搜索条数
      hasNotMore: false, //没有更多了
      hasNotMoreSearch: false, //没有更多了结果了
      isShowTooltip: false, //展示气泡
    };
  },
  methods: {
    onMouseOver(str) { // 内容超出，显示文字提示内容
      const tag = this.$refs[`str${str}`]
      const parentWidth = tag[0].parentNode.offsetWidth // 获取元素父级可视宽度
      const contentWidth = tag[0].offsetWidth // 获取元素可视宽度
      this.isShowTooltip = contentWidth <= parentWidth
    },
    //全选/全不选
    changeCheckedAll(val) {
      // this.curDepartList.forEach(item => item.checked = val)
      this.curDepartList = this.curDepartList.map(item => {
        item.checked = val
        return item
      })
      this.curStudentList = this.curStudentList.map(item => {
        //如果已加入不改
        if (item.companyStatus != 1) {
          item.checked = val
        }
        return item
      })
      if (val) {
        this.checkedList = this.checkedList.filter(x => !this.curDepartList.some(y => y.id === x.id))
        this.checkedList = this.checkedList.filter(x => !this.curStudentList.some(y => y.id === x.id))
        this.checkedList.push(this.breadcrumbList[this.breadcrumbList.length - 1])
      } else {
        this.checkedList = this.checkedList.filter(item => item.id != this.breadcrumbList[this.breadcrumbList.length - 1].id)
      }
      // let arr = JSON.parse(JSON.stringify(this.checkedList))
      // let arr2 = []
      // let departArr = JSON.parse(JSON.stringify(this.curDepartList))
      // let studentArr = this.curStudentList.filter(item => item.companyStatus != 1)
      // arr2.push(...departArr)
      // arr2.push(...studentArr)
      // if (val) {
      //   this.checkedList = arr.reduce((a, b) => {
      //     let isFlag = false
      //     a.forEach(item => {
      //       if (item.id === b.id) {
      //         isFlag = true
      //         item = Object.assign(item, b)
      //       }
      //     })
      //     if (!isFlag) {
      //       a.push(b)
      //     }
      //     return a
      //   }, arr2)
      // } else {
      //   this.checkedList = arr.filter(item => !arr2.some(ele => ele.id === item.id));
      // }
    },
    //选框改变时
    changeCheckBox(val, i) {
      if (val) {
        this.curStudentList = this.curStudentList.map(item => {
          if (item.id == i.id) {
            item = i
          }
          return item
        })
        this.checkedList.push(i)
        this.$nextTick(() => {
          //如果全选中了
          let flag = this.curDepartList.every(item => item.checked == true) && this.curStudentList.every(item => item.checked == true)
          if (flag) {
            this.checkedList = this.checkedList.filter(x => !this.curDepartList.some(y => y.id === x.id))
            this.checkedList = this.checkedList.filter(x => !this.curStudentList.some(y => y.id === x.id))
            this.checkedList.push(this.breadcrumbList[this.breadcrumbList.length - 1])
          }
        })
      } else {
        this.curStudentList = this.curStudentList.map(item => {
          if (item.id == i.id) {
            item = i
          }
          return item
        })
        this.checkedList.forEach((item, index) => {
          if (item.id == i.id) {
            this.checkedList.splice(index, 1)
          }
          if (item.id == this.breadcrumbList[this.breadcrumbList.length - 1].id) {
            this.checkedList.splice(index, 1)
            let arr = this.curDepartList.filter(item => item.checked == true)
            let arr1 = this.curStudentList.filter(item => item.checked == true && item.companyStatus != 1)
            this.checkedList.push(...arr)
            this.checkedList.push(...arr1)
          }
        })
      }
    },
    //搜索选框改变时
    changeSearchCheckBox(val, i) {
      if (val) {
        //判断有欸有
        let flag = this.checkedList.findIndex(item => item.id == val.id)
        if (flag == '-1') {
          this.checkedList.push(i)
          this.curStudentList.forEach(item => {
            if (item.id == i.id) {
              item.checked = true
            }
          })
        }
      } else {
        this.checkedList.forEach((item, index) => {
          if (item.id == i.id) {
            this.checkedList.splice(index, 1)
          }
        })
        this.curStudentList.forEach(item => {
          if (item.id == i.id) {
            item.checked = false
          }
        })
      }
    },
    //获取当前学生成员列表
    async getCurStudentList(params) {
      params = params || {
        filter: {
          departId: this.curGroup.id,
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code
        }
      }
      let res = await queryPageTeam(params)
      if (res.success) {
        let arr = res.result
        //如果是已加入，默认选中
        arr.forEach(i => {
          if (i.companyStatus == 1) {
            i['checked'] = true
            i['disabled'] = true
            // arr2.push(i)
          }
        })
        //已选中，再次获取继续选中
        arr.forEach(i => {
          this.checkedList.forEach(j => {
            if (i.id == j.id) {
              i.checked = true
            }
            if (j.id == this.curGroup.id || j.id == 1) {
              i.checked = true
            }
          })
        })
        this.curStudentList.push(...arr)
        this.hasNotMore = true
        this.isShowListBox = true
      }
    },
    //获取被选中的部门和人员
    getCheckedList() {

    },
    //是否可以删除
    handleClosable(tag) {
      if (tag.hasOwnProperty('companyStatus')) {
        return tag.companyStatus != 1
      } else {
        return true
      }
    },
    //删除tag
    handleClose(tag) {
      console.log(tag,'#####');
      this.checkedList.splice(this.checkedList.indexOf(tag), 1);
      if('userId' in tag && tag.userId){
        this.curStudentList.forEach(item => {
          if (item.id == tag.id) {
            item.checked = false
          }
        })
      }else{
        const index = this.curDepartList.findIndex((item) => item.id == tag.id);
        if(index != '-1'){
           this.curDepartList.forEach((item) => {
            if (item.id == tag.id) {
              item.checked = false;
              if (item.children.length > 0) {
                this.setChildrenAttribute(item.children, "checked", false);
              }
            }
          });
        } else {
          //如果没找到就在完整的组织架构this.departList中去找，找之后将其设置为false，然后将其子部门递归设置为false
          this.setChildrenCheckedFalse(this.departList,tag.id)
        }
        //判断删除的部门是不是当前部门的父级部门，如果是将当前的学生列表都设置为false
        if (this.breadcrumbList.find(item=>item.id ==tag.id)) {
          this.curStudentList.forEach(item => {
            if (item.companyStatus != 1) {
              item.checked = false
            }
          })
        }
      }
      // this.checkedList.splice(this.checkedList.indexOf(tag), 1);
      // if (this.breadcrumbList[this.breadcrumbList.length - 1].id == tag.id) {
      //   this.curDepartList.forEach(item => {
      //     item.checked = false
      //   })
      //   this.curStudentList.forEach(item => {
      //     if (item.companyStatus != 1) {
      //       item.checked = false
      //     }
      //   })
      // }
      // this.curDepartList.forEach(item => {
      //   if (item.id == tag.id) {
      //     item.checked = false
      //   }
      // })
      // this.curStudentList.forEach(item => {
      //   if (item.id == tag.id) {
      //     item.checked = false
      //   }
      // })
    },

     //将目标组织和其子组织的checked属性设置为false
    setChildrenCheckedFalse(departments, targetId) {
      for (let i = 0; i < departments.length; i++) {
        const department = departments[i];
        if (department.id === targetId) {
          // 找到目标组织，将其所有子部门的checked属性设置为false
          department.checked =false
          this.setChildrenAttribute(department.children, "checked", false);
          break;
        } else if (department.children && department.children.length > 0) {
          // 继续搜索子孙部门
          this.setChildrenCheckedFalse(department.children, targetId);
        }
      }
    },
    setChildrenAttribute(children, attr, value) {
      children.forEach((child) => {
        child[attr] = value;
        if (child.children && child.children.length > 0) {
          this.setChildrenAttribute(child.children, attr, value);
        }
      });
    },
    //点击搜索
    handelerSeachClick() {
      this.searchList = []
      this.isShowSearchBox = true
      console.log(this.searchVal == '');
      if (this.searchVal == '') {
        this.isShowSearchBox = false
        return
      }
      this.search()
    },
    //搜索
    async search() {
      let params = {
        filter: {
          nickName: this.searchVal,
        },
      }
      let res = await queryPageTeam(params)
      if (res.success) {
        let arr = res.result
        if (arr.length == 0) {
          this.$message.warning(this.$t('managementV2.notFindResult'))
        }
        arr.forEach(i => {
          this.checkedList.forEach(j => {
            if (i.id == j.id) {
              i['checked'] = true
              i['disabled'] = true
            }
          })
        })
        this.searchList.push(...arr)
        if (this.searchList.length == res.totalRows) {
          this.hasNotMore = true
        }
        this.isShowListBox = true
      }
    },
    //获取所有的学生
    async queryAllStudentList() {
      let params = {
        filter: {
          nickName: '',
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
        }
      }
      let res = await queryPageTeam(params)
      if (res.success) {
        let arr = res.list
        arr.forEach(item => {
          if (item.companyStatus == 1) {
            this.checkedList.push(item)
          }
        })
      }
    },
    //清空
    changeClear() {
      this.isShowSearchBox = true
      this.searchVal = ''
      this.searchList = []
    },
    //获取焦点
    handleFocus() {
      this.isShowSearchBox = true
    },
    //去下级部门
    toChildrenDepart(item) {
      this.stuPage = 1
      this.isShowListBox = false
      this.hasNotMore = false
      this.curGroup = item
      this.getBrnList(item)
      this.curStudentList = []
      this.curDepartList = [...item.children]
      this.getCurStudentList()
      // let params = {
      //   filter: {
      //     classId: this.addstudentId,
      //     departId: item.id,
      //     companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
      //   }
      // }
      // const { success } = this.getCurStudentList(params)
      // if (success) {
      //   this.isShowListBox = true
      // }
    },
    //点击面包屑
    handelerClickBread(item, index) {
      if (index == (this.breadcrumbList.length - 1)) {
        return
      } else {
        this.curGroup = item
        this.curStudentList = []
        this.stuPage = 1
        this.isShowListBox = false
        this.hasNotMore = false
        this.isShowListBox = false
        this.getBrnList(item)
        let arr = [...item.children]
        arr.forEach(i => {
          i.checked = false
          this.checkedList.forEach(j => {
            if (i.id == j.id) {
              i.checked = true
            }
            if (j.id == i.parentId) {
              i.checked = true
            }
          })
        })
        this.curDepartList = arr
        // let params = {
        //   filter: {
        //     classId: this.addstudentId,
        //     departId: item.id,
        //     companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
        //   }
        // }
        if (item.id == 1) {
          this.curGroup = this.isDefaultGroup
        }
        this.getCurStudentList()
      }
    },
    //获取面包屑列表
    getBrnList(data) {
      let arr = [...this.treeData]
      let newArr = []
      function getAllParentNodeIds(tree, childId, parentIds) {
        for (let i in tree) {
          let item = tree[i]
          if (item.id === childId.id) {
            //将查找到的目标数据加入结果数组中
            //可根据需求unshift(item.id)或unshift(item)
            parentIds.unshift(item)
            return true
          }
          if (item.children && item.children.length > 0) {
            let ok = getAllParentNodeIds(item.children, childId, parentIds)
            if (ok) {
              parentIds.unshift(item)
              return true
            }
          }
        }
        //走到这说明没找到目标
        return false
      }
      getAllParentNodeIds(arr, data, newArr)
      //存到vuex
      this.breadcrumbList = newArr
    },
    //获取树形结构数据
    async getTerrClass() {
      let params = {
        companyCode: this.companyCode,
        // identityType: 2,  //西安版本不传
      }
      let { success, result } = await queryUserDepartTree(params);
      if (success) {
        //初始面包屑列表
          this.breadcrumbList.push(result);
        this.treeData = [result];
        let arr = result.children.filter((item) => item.isDefaultGroup !== 1);
        this.isDefaultGroup = result.children.find(
          (item) => item.isDefaultGroup === 1
        );
        this.departList = [result];
        this.departList[0].children = arr;
        //去掉未分组
        this.breadcrumbList[0].children = arr;
        this.addCheckedAttribute(this.departList);

        this.curDepartList = this.departList[0].children;
        // // 拿到未分组id
        this.noGroupId = this.isDefaultGroup.id;
        this.curGroup = Object.assign(this.isDefaultGroup);
        this.getCurStudentList()
      }
    },
    //给部门列表添加checked属性
    addCheckedAttribute(departments) {
      departments.forEach((item) => {
        this.$set(item, "checked", false);
        if (item.children) {
          this.addCheckedAttribute(item.children);
        }
      });
    },
    //滚动请求
    toLoadMore() {
      let scrollDom = this.$refs.scrollBox
      if (scrollDom.clientHeight + scrollDom.scrollTop + 1 >= scrollDom.scrollHeight) {
        // this.currentPage ++ //页数加一
        this.getCurStudentList() //发送请求获取数据
      }
    },
    toLoadMoreSearch() {
      let scrollDom = this.$refs.searchScrollBox
      if (scrollDom.clientHeight + scrollDom.scrollTop + 1 >= scrollDom.scrollHeight) {
        this.search() //发送请求获取数据
      }
    },
    async handleConfirm() {
      if (this.Debounce) {
        return false
      }
      this.Debounce = true;
      let timer = window.setTimeout(() => {
        clearTimeout(timer)
        this.Debounce = false;
      }, 1000)
      if (this.roleId == '') {
        this.$message.warning(this.$t("managementV2.pleaseselectRole"));
        return;
      }

      let arr = [...this.checkedList]
      let departIdList = []
      let userIdList = []
      arr.forEach(item => {
        if (item.hasOwnProperty('companyStatus')) {
          userIdList.push(item.userId)
        } else {
          departIdList.push(item.id)
        }
      })

      const resourceIds = await this.getRoleResource();
      const roleName = this.roleList.find(item => item.id == this.roleId).name;
      let { success } = await inviteUserBatch({
        userIds: userIdList,
        departIdList,
        resourceIds,
        roleId: this.roleId,
        roleName,
      });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t("managementV2.useraddSuccessed"));
        this.$emit('updateTeamList');
        this.handleCancel()
      }
    },
    //取消
    handleCancel() {
      this.roleId = ''
      this.stuPage = 1
      this.searchVal = ''
      this.breadcrumbList = []
      this.departList = []
      this.curDepartList = []
      this.curStudentList = []
      this.checkedList = []
      this.checkedAll = false
      this.isShowSearchBox = false
      this.isShowListBox = false
      this.searchList = []
      this.$emit('batchAddCancel');
    },
    roleFormate(row) {
      return this.roleArr.find(item => item.value === row.identityType).label;
    },
    statusFormate(status) {
      // companyStatus;         //团队状态:  -1.删除 0.禁用 1.已加入 2.未激活 3.取消邀请 4.已拒绝  null：未加入
      switch (status) {
        case 1:
          return this.$t('managementV2.joined');
        default:
          return this.$t('managementV2.notToJoin');
      }
    },
    async getRoleResource() {
      let self = this;
      const { success, result } = await getRoleId({
        id: self.roleId,
        resType: 'CATWEB',
      });
      if (success) {
        // 拿到     CAT     菜单的权限
        // let arr = result.filter(item => item.resType === 'CATWEB').slice(0, 6);
        return result.map((item) => {
          return item.id;
        });
      }
    },
  },
  watch: {
    batchAddVisible: {
      handler(newVal) {
        if (newVal) {
          // this.queryAllStudentList()
          this.getTerrClass();
          this.$nextTick(() => {
            document.addEventListener("click", (e) => {
              if (this.$refs.tree && !this.$refs.tree.contains(e.target)) {
                this.isShowSearchBox = false
                this.hasNotMoreSearch = false
              }
            });
          });
        }
      }
    },
    // roleList: {
    //   handler(newVal) {
    //     this.roleId = newVal[0].id;
    //   },
    //   deep: true,
    // },
    curDepartList: {
      handler(val) {
        if (val.length > 0) {
          this.checkedAll = val.every(item => item.checked == true) && this.curStudentList.every(item => item.checked == true)
        } else {
          this.checkedAll = this.curStudentList.every(item => item.checked == true)
        }

      }, deep: true
    },
    curStudentList: {
      handler(val) {
        if (val.length > 0) {
          this.checkedAll = val.every(item => item.checked == true) && this.curDepartList.every(item => item.checked == true)
        } else {
          this.checkedAll = this.curDepartList.every(item => item.checked == true)
        }
        // this.getCheckedList()
      }, deep: true
    },
    isShowSearchBox: {
      handler(val) {
        if (!val) {
          this.searchList = []
        }
      }, deep: true
    },
    breadcrumbList: {
      handler() {
        let ele = this.$refs.breadcrumb
        this.$nextTick(() => {
          ele.scrollLeft = ele?.scrollWidth - ele.clientWidth
        })
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/index.less";
</style>